module.exports = __webpack_public_path__ + "assets/3e679b2a22de1e5c8717d2b660c0165a.wav";